<script setup lang="ts">
import { computed } from 'vue'
import { useTranslations } from '@/translation'
import { VueFinalModal } from 'vue-final-modal'
import { useWidget } from '@/widget'
import LogoFooter from '@/components/LogoFooter.vue'
import { X } from 'lucide-vue-next'
const { t } = useTranslations()
const { getOption } = useWidget()
const menus = computed(() => getOption('menu'))
const emit = defineEmits(['update:show', 'show:rodo', 'update:modelValue'])
const handleAction = (menu) => {
  if (menu.key === 'rodo') {
    emit('show:rodo', menu)
  } else return
}
</script>

<template>
  <VueFinalModal
    content-class="absolute bottom-0 w-full p-4 pb-0 bg-white dark:bg-white space-y-2 rounded-t-xl"
    swipe-to-close="down"
    content-transition="vfm-slide-down"
    overlay-transition="vfm-fade"
    overlay-class="!bg-backdrop-color"
    @update:model-value="(val) => emit('update:modelValue', val)"
    role="dialog"
    :aria-label="t('context.title')"
    aria-modal="true"
  >
    <div v-if="menus.length">
      <button
        @click="emit('update:modelValue', false)"
        class="absolute top-0 right-0 p-4 rounded-full hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary/50 transition-colors duration-200"
        type="button"
        :aria-label="t('aria.closeModal')"
      >
        <X aria-hidden="true" />
      </button>
      <h2 id="modal-title" class="text-lg font-semibold">{{ t('context.title') }}</h2>
      <nav role="navigation" :aria-labelledby="'modal-title'">
        <div class="flex-grow flex flex-col px-8 py-2 overflow-y-auto space-y-2 my-4">
          <button
            v-for="menu in menus"
            :key="menu.key"
            @click="handleAction(menu)"
            class="w-full flex items-center p-3 text-left hover:bg-suggestion focus:bg-suggestion rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 transition-colors duration-200"
            type="button"
            :aria-label="t('context.button.' + menu.key)"
          >
            <span
              v-if="menu.icon"
              class="w-7 h-7 flex items-center justify-center rounded-full p-1 mr-2"
              aria-hidden="true"
            >
              <img :src="menu.icon" class="w-full h-full" :alt="''" />
            </span>
            {{ t('context.button.' + menu.key) }}
          </button>
        </div>
      </nav>
      <LogoFooter :dark-logo="true" />
    </div>
  </VueFinalModal>
</template>
